<script lang="ts">
  // UI components
  import { Checkbox } from '$lib/components/ui/checkbox/index.js';
  import { Input } from '$lib/components/ui/input/index.js';
  import { Label } from '$lib/components/ui/label/index.js';

  // RoastLog
  import type { EventScale } from '$lib/types/RoastLog';

  interface Props {
    eventScale: EventScale | undefined;
    counter: number;
    sendUpdate: CallableFunction;
  }

  let {
    eventScale = $bindable(),
    counter = 0,
    sendUpdate = (i: number): void => {
      throw new Error('Function not implemented.');
    }
  }: Props = $props();

  let checked = $state(
    eventScale && (eventScale.max !== null || eventScale.min !== null || eventScale.step !== null)
  );

  const toggleValueSelectors = (i: number) => {
    if (!eventScale) {
      return;
    }

    if (checked) {
      eventScale.min = null;
      eventScale.max = null;
      eventScale.step = null;
    } else {
      eventScale.min = '0';
      eventScale.max = '10';
      eventScale.step = '0.5';
    }

    sendUpdate(i);
  };
</script>

<div class="flex items-center gap-x-4 lowercase">
  <Checkbox bind:checked onclick={() => toggleValueSelectors(counter)} />
  {#if eventScale && checked}
    <div class="flex flex-col items-center">
      <Label class="mb-1 font-light" for="max-value-selector-{counter}">Min</Label>
      <Input
        id="max-value-selector-${counter}"
        class=" flex-1 text-center"
        type="number"
        placeholder="Min"
        min="0"
        bind:value={eventScale.min}
        step={eventScale.step}
        onblur={(e) => sendUpdate(counter)}
      />
    </div>

    <div class="flex flex-col items-center">
      <Label class="mb-1 font-light" for="min-value-selector-{counter}">Max</Label>
      <Input
        id="min-value-selector-${counter}"
        class=" flex-1 text-center"
        type="number"
        placeholder="Max"
        bind:value={eventScale.max}
        step={eventScale.step}
        onblur={(e) => sendUpdate(counter)}
      />
    </div>
    <div class="flex flex-col items-center">
      <Label class="mb-1 font-light" for="step-value-selector-{counter}">Step</Label>
      <Input
        id="step-value-selector-${counter}"
        class="flex-1 text-center"
        type="number"
        placeholder="Step"
        bind:value={eventScale.step}
        step={eventScale.step}
        min="0.01"
        onblur={(e) => sendUpdate(counter)}
      />
    </div>
  {/if}
</div>
